import { render } from "./formModal.vue?vue&type=template&id=a8fe64c2&scoped=true"
import script from "./formModal.vue?vue&type=script&lang=js"
export * from "./formModal.vue?vue&type=script&lang=js"

import "./formModal.vue?vue&type=style&index=0&id=a8fe64c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8fe64c2"]])

export default __exports__